import { render } from "./BaseRequiredSelect.vue?vue&type=template&id=8177a0de"
import script from "./BaseRequiredSelect.vue?vue&type=script&lang=js"
export * from "./BaseRequiredSelect.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maksimzugan/code/nacd-3-family/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__